import { useParams } from "react-router";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "@refinedev/react-hook-form";

import { StoreFormValues, storeSchema } from "@modules/stores/validations/storeSchema";
import { useEditStoreMutation } from "@modules/stores/services/mutations";

export function useStoreEditForm() {
  const { id } = useParams();
  const { mutateAsync, isPending } = useEditStoreMutation(id as string);

  const methods = useForm<StoreFormValues>({
    resolver: zodResolver(storeSchema()),
    defaultValues: {
      country: "Brasil",
      active: true,
    },
    mode: "onBlur",
  });

  const {
    handleSubmit,
    refineCore: { formLoading },
  } = methods;

  return {
    methods,
    handleSubmit,
    mutateAsync,
    isPending,
    formLoading,
    id,
  };
}
